<section class="kpis" aria-label="شاخص‌های اصلی عملکرد خودرو" [attr.aria-busy]="loading">
  <article class="kpi-card">
    <h2>مسافت طی‌شده</h2>
    <div class="kpi-value">
      <ng-container *ngIf="!loading && summary?.TotalDistance != null; else unavailable">
        <span>{{ summary.TotalDistance | number:'1.0-1':'en-US' }}</span>
        <span class="kpi-unit">km</span>
      </ng-container>
    </div>
    <p>مجموع مسافت ثبت‌شده</p>
  </article>

  <article class="kpi-card">
    <h2>حداکثر سرعت</h2>
    <div class="kpi-value">
      <ng-container *ngIf="!loading && summary?.MaxSpeed != null; else unavailable">
        <span>{{ summary.MaxSpeed | number:'1.0-0':'en-US' }}</span>
        <span class="kpi-unit">km/h</span>
      </ng-container>
    </div>
    <p>بیشترین مقدار روز</p>
  </article>

  <article class="kpi-card">
    <h2>میانگین سرعت حرکت</h2>
    <div class="kpi-value">
      <ng-container *ngIf="!loading && summary?.AvgMovingSpeed != null; else unavailable">
        <span>{{ summary.AvgMovingSpeed | number:'1.0-1':'en-US' }}</span>
        <span class="kpi-unit">km/h</span>
      </ng-container>
    </div>
    <p>فقط هنگام حرکت</p>
  </article>

  <article class="kpi-card">
    <h2>میانگین ولتاژ موتور روشن</h2>
    <div class="kpi-value">
      <ng-container *ngIf="!loading && summary?.AvgEngineOnVoltage != null; else unavailable">
        <span>{{ summary.AvgEngineOnVoltage | number:'1.2-2':'en-US' }}</span>
        <span class="kpi-unit">V</span>
      </ng-container>
    </div>
    <p>هنگام روشن بودن موتور</p>
  </article>

  <article class="kpi-card">
    <h2>بازه ولتاژ</h2>
    <div class="kpi-value kpi-value--range">
      <ng-container *ngIf="!loading && summary?.MinVoltage != null && summary?.MaxVoltage != null; else unavailable">
        <span dir="ltr">{{ summary.MinVoltage | number:'1.2-2':'en-US' }} – {{ summary.MaxVoltage | number:'1.2-2':'en-US' }}</span>
        <span class="kpi-unit">V</span>
      </ng-container>
    </div>
    <p>کمینه و بیشینه ثبت‌شده</p>
  </article>

  <article class="kpi-card">
    <h2>زمان روشن بودن</h2>
    <div class="kpi-value kpi-value--duration">
      <ng-container *ngIf="!loading; else unavailable">{{ engineOnDuration }}</ng-container>
    </div>
    <p>مدت روشن بودن موتور</p>
  </article>
</section>

<ng-template #unavailable><span class="kpi-unavailable" aria-label="اطلاعات موجود نیست">—</span></ng-template>
